import * as React from "react";

interface SvgComponentProps {
	[key: string]: any;
}
const DeleteIcon: React.FC<SvgComponentProps> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={26}
		height={26}
		viewBox="0 0 26 26"
		fill="none"
		{...props}
	>
		<path
			fill="#CB4141"
			fillRule="evenodd"
			d="M8.5 4.5c0-.414.336-.75.75-.75h7.5c.414 0 .75.336.75.75v2h4.75c.414 0 .75.336.75.75s-.336.75-.75.75H3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H8.5v-2ZM6.5 10.5h13v11c0 1.105-.895 2-2 2h-9c-1.105 0-2-.895-2-2v-11Zm3-1.5h5.5v-1.5h-5.5v1.5Zm2 9.5v-4h1.5v4h-1.5Z"
			clipRule="evenodd"
		/>
		<path
			fill="#CB4141"
			fillRule="evenodd"
			d="M13 17.5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0 .276.224.5.5.5ZM10.25 17.5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0 .276.224.5.5.5ZM15.75 17.5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0 .276.224.5.5.5Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default DeleteIcon;
